export default __webpack_public_path__ + "static/media/Background_00060.e94a98c5.png";